var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusParsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#054254",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_10743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43055 14.5694V17.4514C9.43055 19.043 8.14026 20.3333 6.54861 20.3333C4.95696 20.3333 3.66667 19.043 3.66667 17.4514C3.66667 15.8597 4.95696 14.5694 6.54861 14.5694H14.8819C17.8927 14.5694 20.3333 12.1288 20.3333 9.11805C20.3333 6.10733 17.8927 3.66666 14.8819 3.66666C11.8712 3.66666 9.43055 6.10733 9.43055 9.11805V11.7917",
    stroke: "#054254",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_10743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusParsed);
export default __webpack_public_path__ + "static/media/status-parsed.324a1adb6404a10cefc1c5aa7f4214b6.svg";
export { ForwardRef as ReactComponent };